export default "__VITE_ASSET__3cb492d7__"